site.megamenu = {
	hasExtras:['stjornsysla', 'mannlif'],
	init:function() {
		var $mainmenu = $('#mainmenu');
		$('.mmLevel2', $mainmenu).wrap('<div class="megamenu"><div class="wrap"><div class="contentWrap" /></div></div>');
		$mainmenu.on('click', function(e) {
			e.stopPropagation();
		});

		$('.level1.children > a',$mainmenu).on('click', function (e) {
			if ($(document).width()+15 >= 992) {
				e.preventDefault();
				e.stopPropagation();

				//Click on node that is already open
				if ($(this).parent().hasClass('open')) {
					site.megamenu.close();
				}
				//Open megamenu
				else {
					$('body').addClass('megamenu-open');
					$('.level1.open', $mainmenu).removeClass('open');
					$('.megamenu', $mainmenu).removeAttr('style');
					$(this).parent().addClass('open');
					site.megamenu.setHeight();
				}

				$('body.megamenu-open').on('click', function (e) {
					site.megamenu.close();
				});
			}
		});

		$(window).resize(function() {
			site.megamenu.setHeight();
		});
		site.megamenu.loadLinks();
	},

	setHeight:function() {
		var $megamenu = $('.megamenu', '#mainmenu .level1.open');
		if ($megamenu.length > 0) {
			var $megamenuHeight = $megamenu[0].scrollHeight + 5;
			$megamenu.css('max-height', $megamenuHeight);
			$('#pageContainer').css('min-height', $megamenuHeight+142);
		}
	},

	close:function() {
		var $body = $('body'),
			$mainmenu = $('#mainmenu');
		$('.megamenu', $mainmenu).removeAttr('style');
		$('.level1.open', $mainmenu).removeClass('open');
		$('#pageContainer').removeAttr('style');

		if ($body.hasClass('megamenu-open')) {
			$body.addClass('megamenu-closing');
			setTimeout(function() {
				$body.removeClass('megamenu-closing');
			},400);
		}
		$body.removeClass('megamenu-open');
	},

	loadLinks:function() {
		$('.megamenu', '#mainmenu').each(function() {
			var $megamenu = $(this),
				$li = $megamenu.parents('.level1'),
				$a = $li.find("> a:not(.expand)"),
				href = $a.attr('href'),
				codename = (href) ? href.replace('/is/', '') : '';

			if (site.megamenu.hasExtras.indexOf(codename) >= 0) {
				$.ajax({
					url: '/moya/extras/megamenu-'+codename,
					type: 'get'
				}).done(function(r) {
					if (r.length) {
						$megamenu.find('.contentWrap').append(r);
					}
				});
			}

			if (codename == 'mannlif') {
				$('.mmLevel2', $megamenu).remove();
			}
		});
	}
};
